/**
 * @license
 * Copyright (c) 2016 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
 */

import '@polymer/iron-iconset-svg/iron-iconset-svg.js';
const $_documentContainer = document.createElement('template');
$_documentContainer.innerHTML = `<iron-iconset-svg name="cs-toty" style="display: none;">
<svg>
  <g id="download" viewBox="0 0 16 20">
    <path d="M6.71513 15.1908L7.42475 15.4847L8.13438 15.1908L13.9397 9.38553C14.3314 8.9938 14.3314 8.358 13.9397 7.96628C13.5479 7.57455 12.9121 7.57455 12.5204 7.96628L8.42875 12.0579V1.00353C8.42875 0.449399 7.97935 0 7.42522 0C6.87108 0 6.42168 0.449399 6.42168 1.00353V12.0584L2.32956 7.96628C1.93784 7.57455 1.30203 7.57455 0.91031 7.96628C0.518585 8.358 0.518585 8.9938 0.91031 9.38553L6.71513 15.1908Z"></path>
    <path d="M14.3225 17.9929H1.00353C0.449399 17.9929 0 18.4423 0 18.9965C0 19.5506 0.449399 20 1.00353 20H14.3225C14.8767 20 15.3261 19.5506 15.3261 18.9965C15.3261 18.4423 14.8771 17.9929 14.3225 17.9929Z"></path>
  </g>
  <g id="remove" viewBox="0 0 29 30">
    <path clip-rule="evenodd" d="M14.4399 29C22.1719 29 28.4399 22.732 28.4399 15C28.4399 7.26801 22.1719 1 14.4399 1C6.70795 1 0.439941 7.26801 0.439941 15C0.439941 22.732 6.70795 29 14.4399 29Z" stroke-width="0.711997"></path>
    <rect style="fill: var(--iron-icon-stroke-color);" x="7.56006" y="14.5283" width="14.2399" height="1.42399" rx="0.711997"></rect>
  </g>
  <g id="back-paddle" viewBox="0 0 40 40">
    <circle r="18.875" transform="matrix(-1 0 0 1 20 20)" stroke-width="2.25"></circle>
    <path d="M22.0002 25.9996L16.5002 19.9996L22.0002 13.9996" stroke-width="2.25"></path>
  </g>
  <g id="forward-paddle" viewBox="0 0 40 40">
    <circle cx="20" cy="20" r="18.875" stroke-width="2.25"></circle>
    <path d="M17.9998 25.9996L23.4998 19.9996L17.9998 13.9996" stroke-width="2.25"></path>
  </g>
</svg>
</iron-iconset-svg>`;

document.head.appendChild($_documentContainer.content);
